import { post } from '@/utils/http.js'

const SET_CHOOSE_ORDERS = 'SET_CHOOSE_ORDERS'
const SET_OPTIONAL_INFO = 'SET_OPTIONAL_INFO'
const SET_INVOICE_INFO = 'SET_INVOICE_INFO'
const CLEAR_INVOICE_STATE = 'CLEAR_INVOICE_STATE'
const SET_ADDRESS_ID = 'SET_ADDRESS_ID'
const SET_OPEN_INVOICE = 'SET_OPEN_INVOICE'
const SHOW_INVOICE_POPUP = 'SHOW_INVOICE_POPUP'
const SET_INVOICE_PDF_URL = 'SET_INVOICE_PDF_URL'
const SET_INVOICE_ADDRESS_ID = 'SET_INVOICE_ADDRESS_ID'
const SET_SELECT_INVOICE_ID = 'SET_SELECT_INVOICE_ID'
const SET_BUY_SERVICES_STATE = 'SET_BUY_SERVICES_STATE'
const SET_SELECT_POPUP_TITLE = 'SET_SELECT_POPUP_TITLE'
const SET_NO_USE_INDEX = 'SET_NO_USE_INDEX'

const state = {
  buyNouseIndex: [], // 未使用优惠券列表
  checkBuyServicesId: '', // 服务单页 服务类型id 4图文问诊 6在线问答 7电话复诊 30视频复诊
  payBuyType: '', // 服务单页 1微信支付 2支付宝
  selectInvoiceId: '', // 随单已提交的发票id
  invoicePdfUrl: '',
  showInvoicePopup: false,
  chooseOrders: [], // 发票订单勾选中的订单id列表
  openInvoiceState: 1, // 1不需要开发票 2 需要开发票
  invoiceInfo: {
    invType: 1, // 发票类型 1-电子发票、2-纸质发票
    type: 1, // 抬头类型 1-企业、2-个人
    consignee: '', // 收货人
    address: '', // 发货地址
    phoneNo: '', // 手机号
    email: '', // 邮箱
    title: '', // 发票抬头
    taxNo: '', // 税号
    amount: '' // 总金额
  },
  optionalInfo: { // 选填信息
    companyAddress: '', // 公司地址
    companyTel: '', // 公司电话
    bank: '', // 开户银行
    bankNo: '', // 卡号
    remarks: '' // 备注
  },
  selectPopupTitle: null,
  invoiceAddressId: '' // 发票地址id
}

const initState = { ...state }

const mutations = {
  [SET_SELECT_POPUP_TITLE] (state, payload) {
    state.selectPopupTitle = payload
  },
  [SET_CHOOSE_ORDERS] (state, payload) {
    state.chooseOrders = payload
  },
  [SET_OPTIONAL_INFO] (state, payload = {}) {
    state.optionalInfo = {
      ...state.optionalInfo,
      ...payload
    }
  },
  [SET_INVOICE_INFO] (state, payload = {}) {
    state.invoiceInfo = {
      ...state.invoiceInfo,
      ...payload
    }
  },
  [CLEAR_INVOICE_STATE] (state, payload = {}) {
    Object.assign(state, initState, {
      payload
    })
    state.selectPopupTitle = null
  },
  [SET_ADDRESS_ID] (state, addressId) {
    state.invoiceInfo.addressId = addressId
  },
  [SET_OPEN_INVOICE] (state, payload) {
    state.openInvoiceState = payload
  },
  [SHOW_INVOICE_POPUP] (state, payload = false) {
    state.showInvoicePopup = payload
  },
  [SET_INVOICE_PDF_URL] (state, payload = '') {
    state.invoicePdfUrl = payload
  },
  [SET_INVOICE_ADDRESS_ID] (state, payload = '') {
    state.invoiceAddressId = payload
  },
  [SET_SELECT_INVOICE_ID] (state, payload = '') {
    state.selectInvoiceId = payload
  },
  [SET_BUY_SERVICES_STATE] (state, { checkServeId = '', payType = '', NouseIndex = [] }) {
    state.checkBuyServicesId = checkServeId
    state.payBuyType = payType
    state.buyNouseIndex = NouseIndex
  }
}

const actions = {
  setChooseOrders ({ commit }, payload = []) {
    commit(SET_CHOOSE_ORDERS, payload)
  },
  setOptionalInfo ({ commit }, payload = {}) {
    commit(SET_OPTIONAL_INFO, payload)
  },
  setInvoiceInfo ({ commit }, payload = {}) {
    commit(SET_INVOICE_INFO, payload)
  },
  clearInvoiceState ({ commit }) {
    commit(CLEAR_INVOICE_STATE)
  },
  submitInvoiceInfoRequest ({ state, getters }, { mode, orderType = 1 }) {
    return post('/invoice/saveInovoiceRecord', {
      mode, // 开票方式：1-随单开票、2-单独开票
      orderType, // 订单类型 默认 1 药单 2 服务单
      ...state.invoiceInfo, // 发票信息
      ...state.optionalInfo, // 选填信息
      amount: state.invoiceInfo.amount.toFixed(2),
      orderNos: getters.chooseOrderIdsList.join(',') // 相关开票订单
    }).then(res => {
      return res
    }).catch(err => Promise.reject(err))
  },
  submitModifyInvoiceInfoRequest ({ state }, { orderType = 1 }) {
    return post('/invoice/repeatDrawInvoice', {
      orderType, // 订单类型 默认 1 药单 2 服务单
      ...state.invoiceInfo, // 发票信息
      ...state.optionalInfo // 选填信息
    }).then(res => {
      return res
    }).catch(err => Promise.reject(err))
  }
}

const getters = {
  chooseOrderIdsList: (state) => (state.chooseOrders.map(item => item.orderNo) || []),
  invoiceInfo: (state) => state.invoiceInfo,
  optionalInfo: (state) => state.optionalInfo,
  totalInvoiceOrderPrice: (state) => state.chooseOrders.reduce((prev, cur) => {
    const price = cur.receiptsPrice + (cur.orderTypes == 4 ? cur.wzPrice : 0) + (cur.discountPrice || 0)
    prev += parseFloat(price)
    return prev
  }, 0),
  openInvoiceState: state => state.openInvoiceState,
  showInvoicePopup: state => state.showInvoicePopup,
  pdfUrl: state => state.invoicePdfUrl,
  invoiceAddressId: state => state.invoiceAddressId,
  selectInvoiceId: state => state.selectInvoiceId,
  checkBuyServicesId: state => state.checkServeId,
  payBuyType: state => state.payBuyType,
  buyNouseIndex: state => state.buyNouseIndex,
  selectPopupTitle: state => state.selectPopupTitle
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice.js